module.exports = __webpack_public_path__ + "img/icon-support.8e25adf5.svg";